import HeroCarousel from './HeroCarousel';

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-foreground-950">
      {/* 全屏背景轮播：流光主视觉 + 智慧农业 / 智慧物流 / 智慧停车真实场景 */}
      <HeroCarousel />

      <div className="pointer-events-none relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto min-h-[560px] md:min-h-[680px] lg:min-h-[760px] flex flex-col justify-center py-28 lg:py-32">
          <div className="max-w-3xl">
            <div className="text-[11px] md:text-sm font-medium tracking-[0.34em] uppercase text-accent-400">
              HUAHUI DIGITAL INTELLIGENCE
            </div>

            <h1 className="mt-5 font-heading font-bold text-background-50 text-[2.25rem] sm:text-[2.9rem] lg:text-[3.75rem] xl:text-[4.1rem] leading-[1.16] tracking-tight">
              以 AIoT 链接万物万事
              <span className="mt-2 block text-[#4DB36C]">让数字能力进入县域与乡村</span>
            </h1>

            <p className="mt-6 max-w-xl text-sm md:text-base lg:text-lg text-foreground-200 leading-relaxed">
              以九畴云市、中仙数智商贸、ePin 食安码、数字红包、自由流停车等产品矩阵，帮助组织构建可落地、可运营、可持续迭代的数智化体系。
            </p>
          </div>
        </div>
      </div>

      {/* 底部渐隐过渡 */}
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-foreground-950 to-transparent pointer-events-none"></div>
    </section>
  );
}